import { RouterPath } from "@/models/enum/routerPath";
import SuperUserWelcomeView from "@/views/super-user/SuperUserWelcomeView.vue";

const superUserRoutes = [
  {
    path: RouterPath.SuperUserWelcome,
    name: RouterPath.SuperUserWelcome,
    component: SuperUserWelcomeView,
    meta: { requiresSuperUser: true },
  },
];

export default superUserRoutes;
